import { render, staticRenderFns } from "./searchinfo.vue?vue&type=template&id=24597c3d&scoped=true&"
import script from "./searchinfo.vue?vue&type=script&lang=js&"
export * from "./searchinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24597c3d",
  null
  
)

export default component.exports